<template>
  <div class="did-floating-label-content">
    <input class="did-floating-input" :type="type" placeholder="" :disabled="disabled" :value="value" @input="onInput">
    <span v-if="percentage" class="percentage-symbol">%</span>
    <label class="did-floating-label">{{ label }}</label>
    <p v-if="error" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'CustomTextField',
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'text'
    },
    percentage: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: "энэ нүдийг бөглөнө үү"
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    }
  }
};
</script>

<style scoped>
.did-floating-label-content {
  position:relative;
  margin-bottom:20px;
  border-radius: 6px;
  width: 100%;
}
.did-floating-label {
  color: var(--gray-color-new);
  font-size:14px;
  font-weight:400;
  position:absolute;
  pointer-events:none;
  left:15px;
  top:15px;
  padding:0 5px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.did-floating-input {
  font-size:14px;
  font-weight: 400;
  display:block;
  width:100%;
  height:54px;
  padding: 0 20px;
  background: var(--gray-color-10-new);
  color: var(--primary-color-new);
  border-radius: 6px;
  box-sizing: border-box;
  border: none;
  outline: none;
  text-decoration: none;
  &:focus{
    padding-top: 12px;
    ~ .did-floating-label{
      top:7px;
      font-size:11px;
    }
  }
}
.percentage-symbol {
  position: absolute;
  right: 16px;
  top: 16px;
  color: var(--primary-color-new);
  font-size: 14px;
  font-weight: 400;
  pointer-events: none;
}

.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top:7px;
  font-size:11px;
}
.did-floating-input:not(:placeholder-shown) {
  padding-top: 12px;
}
</style>
